// extracted by mini-css-extract-plugin
export var radio = "RadioBtn-module--radio--2584a";
export var checkmark = "RadioBtn-module--checkmark--80755";
export var input = "RadioBtn-module--input--f9d0e";
export var name = "RadioBtn-module--name--2811c";